'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".Check-module_svg__uUEA6{height:.75rem;width:.9375rem;fill:#fff}";
var styles = {"svg":"Check-module_svg__uUEA6"};
styleInject["default"](css_248z, '5def6367-af24-4e41-a883-cb252966508f');

exports["default"] = styles;
